import React from 'react';
import { Text } from '../../Atoms';
function OrganismDescriptionSendDocument(props) {
  const elem = document.getElementById("chatbot-insert");
  if (elem && elem.classList) {
    elem.classList.add("hide-chatbot");
    elem.remove();
  }

  function renderHeader() {
    if (props.type && props.category) {
      return (
        <Text
          text={props.type.name === props.category.name ? props.type.name : props.type.name + ' - ' + props.category.name}
          type='h8'
          className='header-description-document'
        />
      );
    }
    return null;
  }
  function renderDescription() {
    if (props.type && props.category) {
      if (props.type?.name === "Facture") {
        if (props.category?.name?.toLowerCase() === 'hospitalisation') {
          return (
            <div className='content-description-doc'>
              {'Si vous remplissez toutes les conditions ci-dessous, '}
              <span className='doc-bold-text'>
                {'vous ne devez pas nous transmettre de facture'}
              </span>
              ,{' le remboursement se fera '}
              <span className='doc-bold-text'>{'automatiquement '}</span>(
              {'5 jours ouvrés après remboursement de la Sécurité Sociale) :'}
              <div className='doc-mar-bot doc-mar-top'>
                <Text
                  text='- Avoir un montant total des soins ne dépassant pas 900€'
                  className='content-description-doc'
                />
                <Text
                  text='- Avoir payé l’intégralité des soins (part Sécurité Sociale et mutuelle)'
                  className='content-description-doc'
                />
                <Text
                  text='- Être en liaison Noémie (liaison entre SPVIE et la Sécurité Sociale, vérifiez votre liaison)'
                  className='content-description-doc'
                />
              </div>
              <Text
                text="Sinon, merci de nous transmettre la facture acquittée de l'établissement hospitalier."
                className='content-description-doc'
              />
            </div>
          );
        }
        if (props.category?.name?.toLowerCase() === 'optique') {
          return (
            <div className='content-description-doc'>
              {
                "Pour une demande de remboursement d'une prestation non prise en charge par la Sécurité sociale (hors nomenclature) supérieure à 100€,"
              }
              <span className='doc-bold-text'>
                {'une facture originale est nécessaire.'}
              </span>
              {'Merci de nous transmettre '}
              <span className='doc-bold-text'>
                {
                  'la facture acquittée ventilant les frais de verres, de montures ou de lentilles + une copie de la prescription médicale '
                }{' '}
              </span>
              {'datant de moins de :'}
              <Text
                text='- 1 an pour les enfants de moins de 16 ans,'
                className='content-description-doc'
              />
              <Text
                text='- 5 ans pour les personnes âgées de 16 à 48 ans(pour les ordonnances établies après le 17 Octobres 2016),'
                className='content-description-doc'
              />
              <Text
                text='- 3 ans pour les personnes âgées de plus de 48 ans.'
                className='content-description-doc doc-mar-bot'
              />
              <Text
                text={
                  'Ces mesures sont en vigueur pour les ordonnance établies à partir du 17 Octobre 2016 selon le décret 2016 - 1381 du 12 Octobre 2016.'
                }
                className='content-description-doc doc-mar-bot'
              />
              {' Vous pouvez également nous transmettre ces documents par '}
              <span className='doc-bold-text'>{'voie postale'}</span>{' '}
              {"à l'adresse ci-dessous:"}
            </div>
          );
        }
        if (props.category?.name?.includes("Douce")) {
          return (
            <div className='content-description-doc'>
              {
                "Pour une demande de remboursement d'une prestation non prise en charge par la Sécurité sociale (hors nomenclature) supérieure à 100€,"
              }{' '}
              <span className='doc-bold-text'>
                {' '}
                {'une facture originale est nécessaire.'}
              </span>
              <br />
              {
                "Pour des actes de chirurgie réfractive, d'implants dentaires hors réseaux, de médecine douce (ostéopathie, acupuncture,...), des prothèses auditives ou d'autres actes, merci de nous transmettre la facture"
              }
              <span className='doc-bold-text'> des frais engagés.</span>
              <Text
                text='Merci de bien vouloir saisir les informations suivantes afin de permettre un traitement plus rapide de votre remboursement. Vous pouvez retrouver les informations sur votre facture.'
                className='content-description-doc'
              />
              {window.innerWidth > 768 && (
                <div style={{ marginTop: '94px' }} className='doc-mar-top'>
                  {' Vous pouvez également nous transmettre ces documents par '}{' '}
                  <span className='doc-bold-text'> {'voie postale'}</span>{' '}
                  {"à l'adresse ci-dessous:"}
                </div>
              )}
            </div>
          );
        }
        if (props.category?.name?.toLowerCase().includes("thermale")) {
          return (
            <div className='content-description-doc'>
              {
                "Pour une demande de remboursement d'une prestation non prise en charge par la Sécurité sociale (hors nomenclature) supérieure à 100€, une "
              }
              <span className='doc-bold-text'>
                {'facture originale est nécessaire.'}
              </span>
              <div className='doc-mar-bot doc-mar-top'>
                {
                  " Pour des actes de chirurgie réfractive, d'implants dentaires hors réseaux, de médecine douce (ostéopathie, acupuncture,...), de prothèse auditive ou d'autres actes, merci de nous transmettre la "
                }
                <span className='doc-bold-text'>
                  {'facture des frais engagés.'}
                </span>
              </div>
              {' Vous pouvez également nous transmettre ces documents par '}
              <span className='doc-bold-text'>{'voie postale'}</span>{' '}
              {"à l'adresse ci-dessous:"}
            </div>
          );
        }
        if (props.category?.name?.toLowerCase() === 'imagerie') {
          return (
            <div className='content-description-doc'>
              {
                "Pour une demande de remboursement d'une prestation non prise en charge par la Sécurité sociale (hors nomenclature) supérieure à 100€, une "
              }
              <span className='doc-bold-text'>
                {'facture originale est nécessaire.'}
              </span>
              <div>
                {'Si vous remplissez toutes les conditions ci-dessous, '}{' '}
                <span className='doc-bold-text'>
                  {'vous ne devez pas nous transmettre de facture'}
                </span>
                , {'le remboursement se fera '}
                <span className='doc-bold-text'>{'automatiquement'}</span>{' '}
                {
                  '(5 jours ouvrés après remboursement de la Sécurité Sociale) :'
                }
              </div>
              <Text
                text='- Avoir un montant total des soins ne dépassant pas 900€'
                className='content-description-doc'
              />
              <Text
                text='- Avoir payé l’intégralité des soins (part Sécurité Sociale et mutuelle)'
                className='content-description-doc'
              />
              <Text
                text='- Être en liaison Noémie (liaison entre SPVIE et la Sécurité Sociale, vérifiez votre liaison)'
                className='content-description-doc doc-mar-bot'
              />
              <div className='doc-mar-bot'>
                {'Sinon, merci de nous transmettre '}{' '}
                <span className='doc-bold-text'>
                  {
                    "la facture acquittée ou la note d'honoraires du praticien détaillant les actes."
                  }
                </span>
              </div>
              {' Vous pouvez également nous transmettre ces documents par '}{' '}
              <span className='doc-bold-text'> {'voie postale'}</span>{' '}
              {"à l'adresse ci-dessous:"}
            </div>
          );
        }
        if (props.category?.name?.toLowerCase() === 'dentaire') {
          return (
            <div className='content-description-doc'>
              <div>
                {
                  "Pour une demande de remboursement d'une prestation non prise en charge par la Sécurité sociale (hors nomenclature) supérieure à 100€, une "
                }
                <span className='doc-bold-text'>
                  {'facture originale est nécessaire.'}
                </span>
              </div>
              {'Si vous remplissez toutes les conditions ci-dessous,'}
              <span className='doc-bold-text'>
                {' '}
                {'vous ne devez pas nous transmettre de facture'}
              </span>
              {', le remboursement se fera '}
              <span className='doc-bold-text'>{'automatiquement'}</span>{' '}
              {' (5 jours ouvrés après remboursement de la Sécurité Sociale) :'}
              <Text
                text='- Avoir un montant total des soins ne dépassant pas 900€'
                className='content-description-doc'
              />
              <Text
                text='- Avoir payé l’intégralité des soins (part Sécurité Sociale et mutuelle)'
                className='content-description-doc'
              />
              <Text
                text='- Être en liaison Noémie (liaison entre SPVIE et la Sécurité Sociale, vérifiez votre liaison)'
                className='content-description-doc doc-mar-bot'
              />
              {'Sinon, merci de nous transmettre '}{' '}
              <span className='doc-bold-text'>
                {
                  "la facture acquittée ou la note d'honoraires du praticien détaillant les actes."
                }
              </span>
              <div className='doc-mar-top'>
                {' Vous pouvez également nous transmettre ces documents par '}{' '}
                <span className='doc-bold-text'> {'voie postale'}</span>{' '}
                {"à l'adresse ci-dessous:"}
              </div>
            </div>
          );
        }
        if (props.category?.name?.toLowerCase().includes("adoption")) {
          return (
            <div className='content-description-doc'>
              <div className='doc-mar-bot'>
                {' '}
                {
                  "Pour une demande de remboursement d'une prestation non prise en charge par la Sécurité sociale (hors nomenclature) supérieure à 100€, une "
                }
                <span className='doc-bold-text'>
                  facture originale est nécessaire.
                </span>
              </div>
              <Text
                text='Merci de nous transmettre :'
                className='content-description-doc'
              />
              <Text
                text="- Un extrait d'acte de naissance + la facture des frais restés à votre charge"
                className='content-description-doc'
              />
              <span className='doc-bold-text'>ou</span>
              <Text
                text="- Le jugement d'adoption plénière + le justificatif des frais engagés"
                className='content-description-doc'
              />
              <div className='doc-mar-top'>
                {' Vous pouvez également nous transmettre ces documents par '}{' '}
                <span className='doc-bold-text'> {'voie postale'}</span>{' '}
                {"à l'adresse ci-dessous:"}
              </div>
            </div>
          );
        }
        if (props.category?.name?.toLowerCase().includes("frais") && props.category?.name?.toLowerCase().includes("obs")) {
          return (
            <div className='content-description-doc'>
              {
                "Pour une demande de remboursement d'une prestation non prise en charge par la Sécurité sociale (hors nomenclature) supérieure à 100€, "
              }
              <span className='doc-bold-text'>
                {'une facture originale est nécessaire.'}
              </span>
              <div className='doc-mar-top'>
                {' '}
                {
                  'Merci de nous transmettre l’acte de décès et la facture des frais engagés.'
                }
              </div>
              <div className='doc-mar-top'>
                {' Vous pouvez également nous transmettre ces documents par '}{' '}
                <span className='doc-bold-text'> {'voie postale'}</span>{' '}
                {"à l'adresse ci-dessous:"}
              </div>
            </div>
          );
        }
        if (props.category?.name?.toLowerCase().includes("auditives") && props.category?.name?.toLowerCase().includes("proth")) {
          return (
            <div className='content-description-doc'>
              Si vous remplissez toutes les conditions ci-dessous,{' '}
              <span className='doc-bold-text'>
                vous ne devez pas nous transmettre de facture
              </span>
              , le remboursement se fera{' '}
              <span className='doc-bold-text'>automatiquement</span> (5 jours
              ouvrés après remboursement de la Sécurité Sociale) :
              <Text
                text='- Avoir un montant total des soins ne dépassant pas 1100€/oreille'
                className='content-description-doc'
              />
              <Text
                text='- Avoir payé l’intégralité des soins (part Sécurité Sociale et mutuelle)'
                className='content-description-doc'
              />
              <Text
                text='- Être en liaison Noémie (liaison entre SPVIE et la Sécurité Sociale, vérifiez votre liaison)'
                className='content-description-doc'
              />
              <div className='doc-mar-top'>
                Sinon, merci de nous transmettre{' '}
                <span className='doc-bold-text'>
                  la facture acquittée du prothésiste.
                </span>
              </div>
              <div className='doc-mar-top'>
                {' Vous pouvez également nous transmettre ces documents par '}{' '}
                <span className='doc-bold-text'> {'voie postale'}</span>{' '}
                {"à l'adresse ci-dessous:"}
              </div>
            </div>
          );
        }
        if (props.category?.name?.toLowerCase() === 'autre') {
          return (
            <>
              <div>
                Pour une demande de remboursement d'une prestation non prise en charge par la Sécurité sociale (hors nomenclature) supérieure à 100€, <span style={{ fontWeight: 700 }}>
                  une facture originale est nécessaire.
                </span>
              </div>
              <div className='doc-mar-bot'>
                {'Vous pouvez également nous transmettre ces documents par '}
                <span className='doc-bold-text'>voie postale</span>{' '}
                {"à l'adresse ci-dessous:"}
              </div>
            </>
          );
        }
        return null;
      }
      if (props.type?.name?.toLowerCase().includes("compte")) {
        if (props.category?.name?.toLowerCase().includes("curit") && props.category?.name?.toLowerCase().includes("sociale")) {
          return (
            <div className='content-description-doc'>
              <Text
                text='Merci de nous transmettre votre décompte.'
                className='content-description-doc doc-mar-bot32'
              />
              <div className='doc-mar-bot'>
                {'Vous pouvez également nous transmettre ces documents par '}
                <span className='doc-bold-text'>voie postale</span>{' '}
                {"à l'adresse ci-dessous:"}
              </div>
            </div>
          );
        }
        if (props.category?.name?.toLowerCase().includes("compl") /* Compleémentaire */) {
          return (
            <div className='content-description-doc'>
              <div className='doc-mar-bot32'>
                {'En cas de surcomplémentaire, merci de nous transmettre le '}
                <span className='doc-bold-text'>
                  {'décompte de première mutuelle (complémentaire).'}
                </span>
              </div>
              <div className='doc-mar-bot24'>
                {'Vous pouvez également nous transmettre ces documents par '}
                <span className='doc-bold-text'>voie postale</span>{' '}
                {"à l'adresse ci-dessous:"}
              </div>
            </div>
          );
        }
        return null;
      }
      if (props.type.name.toLowerCase() === 'banque') {
        if (props.category?.name?.toLowerCase().includes("vements")/*Compte prelevements*/) {
          return (
            <div className='content-description-doc'>
              <Text
                text='Si vous désirez changer de compte pour le prélèvement de vos cotisations, il faut nous transmettre :'
                className='content-description-doc doc-mar-bot24'
              />
              <div className='content-description-doc'>
                {'- Le RIB de votre '}{' '}
                <span className='doc-bold-text'>nouveau</span>{' '}
                {' compte bancaire'}
              </div>
              <div className='content-description-doc doc-mar-bot24'>
                {'- Le mandat SEPA '}
                <span className='doc-bold-text'>{'complété et signé'}</span>
                {
                  ", disponible depuis l'onglet 'Accueil' dans la rubrique 'Mes Documents'."
                }
              </div>
              <div className='doc-mar-bot'>
                {'Vous pouvez également nous transmettre ces documents par '}
                <span className='doc-bold-text'>voie postale</span>{' '}
                {"à l'adresse ci-dessous:"}
              </div>
            </div>
          );
        }
        if (props.category?.name?.toLowerCase().includes("remboursement")/*Compte remboursement*/) {
          return (
            <div className='content-description-doc'>
              <div className='doc-mar-bot32'>
                Si vous désirez changer de compte de remboursements, il faut
                nous transmettre le{' '}
                <span className='doc-bold-text'>
                  RIB de votre nouveau compte bancaire.
                </span>
              </div>
              <div className='doc-mar-bot24'>
                {'Vous pouvez également nous transmettre ces documents par '}
                <span className='doc-bold-text'>voie postale</span>{' '}
                {"à l'adresse ci-dessous:"}
              </div>
            </div>
          );
        }
        return null;
      }
      if (props.type?.name?.toLowerCase() === "devis") {
        if (props.category?.name?.toLowerCase() === "hospitalisation") {
          return (
            <div className='content-description-doc'>
              <div className='content-description-doc doc-mar-bot24'>
                {'Merci de nous transmettre votre'}{' '}
                <span className='doc-bold-text'>devis d’hospitalisation.</span>
              </div>
              <div className='doc-mar-bot'>
                {'Vous pouvez également nous transmettre ces documents par '}
                <span className='doc-bold-text'>voie postale</span>{' '}
                {"à l'adresse ci-dessous:"}
              </div>
            </div>
          );
        }
        if (props.category?.name?.toLowerCase() === "optique") {
          return (
            <div className='content-description-doc'>
              <div className='doc-mar-bot32'>
                Merci de nous transmettre votre
                <span className='doc-bold-text'>
                  {' '}
                  devis optique ainsi que votre ordonnance.
                </span>
              </div>
              <div className='doc-mar-bot24'>
                {'Vous pouvez également nous transmettre ces documents par '}
                <span className='doc-bold-text'>voie postale</span>{' '}
                {"à l'adresse ci-dessous:"}
              </div>
            </div>
          );
        }
        if (props.category?.name?.toLowerCase() === "dentaire") {
          return (
            <div className='content-description-doc'>
              <div className='doc-mar-bot32'>
                Merci de nous transmettre votre
                <span className='doc-bold-text'>
                  {' '}
                  devis dentaire ainsi que votre ordonnance.
                </span>
              </div>
              <div className='doc-mar-bot24'>
                {'Vous pouvez également nous transmettre ces documents par '}
                <span className='doc-bold-text'>voie postale</span>{' '}
                {"à l'adresse ci-dessous:"}
              </div>
            </div>
          );
        }
        if (props.category?.name?.toLowerCase() === "appareillage") {
          return (
            <div className='content-description-doc'>
              <div className='doc-mar-bot32'>
                Merci de nous transmettre votre
                <span className='doc-bold-text'>
                  {' '}{"devis d'appareillage ainsi que votre ordonnance."}
                </span>
              </div>
              <div className='doc-mar-bot24'>
                {'Vous pouvez également nous transmettre ces documents par '}
                <span className='doc-bold-text'>voie postale</span>{' '}
                {"à l'adresse ci-dessous:"}
              </div>
            </div>
          );
        }
        return null;
      }
      if (props.type?.name?.toLowerCase()?.includes("justificatif") && props.type?.name?.toLowerCase()?.includes("enfant")) {
        if (props.category?.name?.toLowerCase().includes("certificat") && props.category?.name?.toLowerCase().includes("scolarit")) {
          return (
            <div className='content-description-doc'>
              <div className='content-description-doc doc-mar-bot24'>
                {'Merci de nous transmettre le'}{' '}
                <span className='doc-bold-text'>
                  certificat de scolarité de votre enfant.
                </span>
              </div>
              <div className='doc-mar-bot'>
                {'Vous pouvez également nous transmettre ces documents par '}
                <span className='doc-bold-text'>voie postale</span>{' '}
                {"à l'adresse ci-dessous:"}
              </div>
            </div>
          );
        }
        if (props.category?.name?.toLowerCase().includes("attestation") && props.category?.name?.toLowerCase().includes("emploi")) {
          return (
            <div className='content-description-doc'>
              <div className='content-description-doc doc-mar-bot24'>
                {'Merci de nous transmettre le'}{' '}
                <span className='doc-bold-text'>
                  {"l'attestation Pôle emploi de votre enfant."}
                </span>
              </div>
              <div className='doc-mar-bot'>
                {'Vous pouvez également nous transmettre ces documents par '}
                <span className='doc-bold-text'>voie postale</span>{' '}
                {"à l'adresse ci-dessous:"}
              </div>
            </div>
          );
        }
        if (props.category?.name?.toLowerCase().includes("enfant") && props.category?.name?.toLowerCase().includes('handicap')) {
          return (
            <div className='content-description-doc'>
              <div className='content-description-doc doc-mar-bot24'>
                {'Merci de nous transmettre '}{' '}
                <span className='doc-bold-text'>
                  la carte mobilité inclusion de votre enfant.
                </span>
              </div>
              <div className='doc-mar-bot'>
                {'Vous pouvez également nous transmettre ces documents par '}
                <span className='doc-bold-text'>voie postale</span>{' '}
                {"à l'adresse ci-dessous:"}
              </div>
            </div>
          );
        }
        if (props.category?.name?.toLowerCase() === 'alternant') {
          return (
            <div className='content-description-doc'>
              <div className='content-description-doc doc-mar-bot24'>
                {'Merci de nous transmettre '}{' '}
                <span className='doc-bold-text'>
                  le contrat de professionnalisation de votre enfant.
                </span>
              </div>
              <div className='doc-mar-bot'>
                {'Vous pouvez également nous transmettre ces documents par '}
                <span className='doc-bold-text'>voie postale</span>{' '}
                {"à l'adresse ci-dessous:"}
              </div>
            </div>
          );
        }
        return null;
      }
      if (props.type?.name?.toLowerCase().includes("portabilit")) {
        if ((props.category?.name?.toLowerCase().includes("mise") && props.category?.name?.toLowerCase().includes("place")) || (props.category?.name?.toLowerCase().includes("attestation") && props.category?.name?.toLowerCase().includes("mutuelle"))) {
          return (
            <div className='content-description-doc'>
              <div className='content-description-doc'>
                {'Afin de bénéficier de la portabilité, merci de'}{' '}
                <span className='doc-bold-text'>nous transmettre soit :</span>
              </div>
              <Text
                text='- La notification d’ouverture de droits à l’allocation d’aide au retour à l’emploi (ARE)'
                className='content-description-doc'
              />
              <Text
                text="- La notification d'aide à la reprise ou la création d’Entreprise (ACCRE, ARCE)"
                className='content-description-doc doc-mar-bot'
              />
              <div className='content-description-doc doc-mar-bot'>
                {'Dans tous les cas, vous devez également'}{' '}
                <span className='doc-bold-text'>
                  {
                    "nous transmettre une attestation sur l'honneur, signée, justifiant l'arrêt de l'utilisation de votre carte de tiers payant."
                  }
                </span>
              </div>
              <div className='doc-mar-bot'>
                {'Vous pouvez également nous transmettre ces documents par '}
                <span className='doc-bold-text'>voie postale</span>{' '}
                {"à l'adresse ci-dessous:"}
              </div>
            </div>
          );
        }
        if (props.category?.name?.toLowerCase().includes("fin") && props.category?.name?.toLowerCase().includes("portabilit")) {
          return (
            <div className='content-description-doc'>
              <div className='content-description-doc doc-mar-bot24'>
                {
                  'Afin de mettre un terme à la portabilité de votre contrat veuillez nous transmettre '
                }{' '}
                <span className='doc-bold-text'>
                  {
                    "la copie du contrat de travail ou l'attestation du Pôle Emploi stipulant la reprise d’activité."
                  }
                </span>
              </div>
              <div className='doc-mar-bot'>
                {'Vous pouvez également nous transmettre ces documents par '}
                <span className='doc-bold-text'>voie postale</span>{' '}
                {"à l'adresse ci-dessous:"}
              </div>
            </div>
          );
        }
        return null;
      }
      if (props.type?.name?.toLowerCase() === "autres") {
        return (
          <div className='doc-mar-bot'>
            {'Vous pouvez également nous transmettre ces documents par '}
            <span className='doc-bold-text'>voie postale</span>{' '}
            {"à l'adresse ci-dessous:"}
          </div>
        )
      }
      return null;
    }
  }
  function renderCommunText() {
    return (
      <div>
        <Text
          text='SPVIE Remboursements'
          className={
            props.type.name.toLowerCase() === 'facture'
              ? 'description-condition-send-document'
              : 'description-condition-send-document doc-mar-bot'
          }
        />
        <Text
          text='CGRM TSA 91005'
          className={
            props.type.name.toLowerCase() === 'facture'
              ? 'description-condition-send-document'
              : 'description-condition-send-document doc-mar-bot'
          }
        />
        <Text
          text='59952 Dunkerque'
          className={
            props.type.name.toLowerCase() === 'facture'
              ? 'description-condition-send-document'
              : 'description-condition-send-document doc-mar-bot'
          }
        />
      </div>
    );
  }

  return (
    <div style={{ marginBottom: '12px' }}>
      {renderHeader()}
      {renderDescription()}
      {(props.category?.name?.toLowerCase() !== 'médecine douce' ||
        (props.category?.name?.toLowerCase() === 'médecine douce' &&
          window.innerWidth > 768)) &&
        renderCommunText()}
    </div>
  );
}
export default OrganismDescriptionSendDocument;
